import React from "react";
import List from '../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import ToolBar from "../../../Common/Toolbar";
import { useHistory } from "react-router-dom";
import StadisticCard from "./StadisticCard";
import CLabel from "../../../Common/CLabel"
import ListPagination from "../../../Templates/List/ListPagination";
import { getHomeStadisticExcelData } from "../../../../services/sBook/book.service";
import { __enum_PageMode, __enum_SystemPages, __SystemPagesPaths, enum__PRIVILEGES } from "../../../../common/Dictionaries";
import { __onGoToManageElement } from "../../../../common/SystemRedirections";
import { _checkSecurityUser } from "../../../../common/Helpers/HLP_Security";
import { useContext } from "react";
import MainAppContext from "../../../../MainAppContext";
import { TooltipHost, TooltipOverflowMode, css, mergeStyleSets } from "@fluentui/react";

function HomeKpiListBox(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.

    const inputParam_BookList = props.bookList !== null && props.bookList !== undefined ? props.bookList: null;
    const inputParam_SetBookList = props.setBookList !== null && props.setBookList !== undefined ? props.setBookList : null;
    const inputParam_SecurityProps = props.securityProps !== null && props.securityProps !== undefined ? props.securityProps : null;

    const inputParam_FilterStartDate = props.filterStartDate !== null && props.filterStartDate !== undefined ? props.filterStartDate : null;
    const inputParam_FilterEndDate = props.filterEndDate !== null && props.filterEndDate !== undefined ? props.filterEndDate : null;
    
    const _priv_canCreateBoard = _checkSecurityUser(contextSite.onlyObserver, null, contextSite.securityProps, null, enum__PRIVILEGES.KPI_CONTRACT_CREATE);

    const onViewItemBoardGapClick = (item) => {
        if (item.type === 'Board') {
            history.push({
                pathname: `${__SystemPagesPaths[__enum_SystemPages.Board].text}/${ item.id }`,
            }) 
        }
        else {
            history.push({
                pathname: `${__SystemPagesPaths[__enum_SystemPages.GapV2].text}/${ item.id }`,
            })  
        }
    }
    const handleExport = (handleDownload, listField) => {  
        getHomeStadisticExcelData(inputParam_FilterStartDate, inputParam_FilterEndDate).then((serviceResponse) => {
            handleDownload(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,");
        });
    };

    const onAddBoard = () => {
        history.push({
            pathname: __SystemPagesPaths[__enum_SystemPages.BoardCreation].text
        })
    }

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });
    const _columns = (inputParam_BookList && inputParam_BookList.data === null) ? [] : 
    [
        {
            key: 'all-props-all-props',
            name: t('data-lang-lbl-item'),
            fieldName: 'all-props-all-props',
            minWidth: 180,
            onRender:(item) => {
                const cards = [];

                item.l_elements.forEach(element => {
                    cards.push({
                        class: "col pt-2",
                        code: element.code,
                        name: element.name,
                        type: t(element.type),
                        amount: `${element.nDataserie}/${element.nDataserie_value}`,
                        icon: element.type,
                        color: element.htmlColor,
                        display: true,
                    })
                });

                return  <>
                            <Row className={`book-status-card-${item.statusId} ps-2 overflow-auto`}>
                                <Col>
                                    <Row className="d-flex">
                                        <Col onClick={() => onViewItemBoardGapClick(item)} style={{cursor : "pointer"}}>
                                            <TooltipHost
                                                overflowMode={TooltipOverflowMode.Self}
                                                hostClassName={css(classNames.overflow)}
                                                content={ item.name }
                                                onTooltipToggle={false}
                                                styles={{
                                                    root: { display: 'block' },
                                                }}
                                            >
                                                <div>
                                                        <Row><Col style={{whiteSpace: "nowrap"}}><CLabel labelText={t('data-lang-lbl-type')} labelValue={ item.type } /> </Col></Row>
                                                        <Row><Col style={{whiteSpace: "nowrap"}}><CLabel labelText={t('data-lang-lbl-name')} labelValue={ item.name } /></Col></Row>                                                                          
                                                </div>
                                            </TooltipHost>
                                        </Col>
                                        <Col className="col-auto">
                                            <div style={{height: "55px", minWidth: "150px"}} className="d-flex mx-auto">
                                                {
                                                    cards.map((card, index) => (
                                                        card.display &&
                                                        <StadisticCard key={index} item={card} arrayLength={cards.length - cards.filter(x => !x.display).length} index={index+1} />
                                                    ))
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </>
            }
        },{
            key: 'id',
            name: t('data-lang-lbl-actions'),
            fieldName: 'id',
            minWidth: 70,
            maxWidth: 70,
            styles: {root: {display: "none"}},
            onRender:(item) => {
                const cards = [];

                item.l_elements.forEach(element => {
                    cards.push({
                        class: "col pt-2",
                        code: element.code,
                        name: element.name,
                        type: t(element.type),
                        amount: `${element.nDataserie}/${element.nDataserie_value}`,
                        icon: element.type,
                        color: element.htmlColor,
                        display: true,
                    })
                });

                return  <></>
            }
        }
    ];

    const displayToolBarBook = inputParam_SecurityProps !== null ? inputParam_SecurityProps.isAdmin : false;

    const toolBarItems_Book  = [
        {
            key: 'add',
            text: t('data-lang-btn-create'),
            iconProps: { iconName: 'Add' },
            onClick: onAddBoard,
        }
    ];   

    return (
        <Card className='book-party-roles-form h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-boxname-boards-gaps')}</b>
                    <div className='d-flex'>
                        <div className='book-toolbar'>
                            {
                                _priv_canCreateBoard.value && _priv_canCreateBoard.mode === __enum_PageMode.Edit &&
                                <ToolBar items={ toolBarItems_Book } styles={{root:{height: "30px"}}} display={ displayToolBarBook } />
                            }
                        </div>
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body className="book-party-roles-form-body h-100">
                <Row>
                    {
                        inputParam_BookList && inputParam_BookList.data && 
                        <List
                            listLocalStoragePageSizeVariableName="homeBookList"
                            className="no-compact-list"
                            manipulateLocalData={ true }
                            data={ inputParam_BookList !== null ? inputParam_BookList : [] }
                            setData={inputParam_SetBookList}
                            columns={_columns} 
                            enableExport={ true }
                            handleExport={ handleExport }
                            exportFileName={"Listado de libros.xlsx"}
                        />
                    }
                </Row>
            </Card.Body>
            <Card.Footer>
                {
                        inputParam_BookList && inputParam_BookList.data && 
                        <>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="homeBookList" 
                            data={ inputParam_BookList !== null ? inputParam_BookList : [] }
                            setData={inputParam_SetBookList} />
                    </>
                }
            </Card.Footer>
        </Card>
    );
}

export default HomeKpiListBox;

